<script setup>
import {ref, reactive, onMounted, nextTick, watchEffect, watch, computed} from 'vue';
import { useCommonComposable } from '@/composables/commonComposable.js';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {useStore} from "vuex";
import SearchOverlay from "@/components/App/search-overlay.vue";

const route = useRoute();
const store = useStore();

const menuElems = ref([
    {
        name: 'Главная',
        url: {name: 'Main'},
        icn: '<svg width="21" height="18" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M12.3349 4.89083L18.6467 5.86377L9.86111 15.2471L0.352539 4.89083L3.81691 0.24707H11.8895L12.3349 4.89083ZM7.49214 9.6253L9.87582 12.2215L14.481 7.30302L11.3974 6.82764L7.49214 9.6253ZM3.02035 4.75486L6.09066 8.09879L10.2876 5.09212L10.2872 5.08722L10.0203 2.30418H4.84876L3.02035 4.75486Z" fill="#6D6F71"/>\n' +
            '<path d="M11.8895 0.24707L12.3349 4.89083L18.6467 5.86377L9.86111 15.2471L0.352539 4.89083L3.81691 0.24707H11.8895ZM0.672676 4.87443L9.86288 14.8839L18.1467 6.03646L12.1075 5.10554L11.6653 0.493923H3.94074L0.672676 4.87443Z" fill="#6D6F71"/>\n' +
            '</svg>',
        icnType: 'fill'
    },
    {
        name: 'Каталог',
        url: {name: 'products'},
        icn: '<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M13.0765 2.07422L18.8458 3.94922V8.63672H15.9612V16.1367C15.9612 16.3854 15.8599 16.6238 15.6795 16.7996C15.4992 16.9754 15.2546 17.0742 14.9996 17.0742H5.38424C5.12922 17.0742 4.88465 16.9754 4.70433 16.7996C4.52401 16.6238 4.4227 16.3854 4.4227 16.1367V8.63672H1.53809V3.94922L7.30732 2.07422C7.30732 2.82014 7.61123 3.53551 8.1522 4.06296C8.69317 4.5904 9.42688 4.88672 10.1919 4.88672C10.957 4.88672 11.6907 4.5904 12.2317 4.06296C12.7726 3.53551 13.0765 2.82014 13.0765 2.07422Z" stroke="#6D6F71" stroke-width="1.8" stroke-linecap="round"/>\n' +
            '</svg>',
        icnType: 'stroke'
    },
    {
        name: 'Поиск',
        url: '',
        icn: '<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M14.2049 13.199L18 16.9933L16.7462 18.2471L12.952 14.452C11.5402 15.5837 9.78419 16.1992 7.9748 16.1967C3.57271 16.1967 0 12.624 0 8.22187C0 3.81978 3.57271 0.24707 7.9748 0.24707C12.3769 0.24707 15.9496 3.81978 15.9496 8.22187C15.9522 10.0313 15.3366 11.7873 14.2049 13.199ZM12.4274 12.5415C13.5519 11.3851 14.18 9.83493 14.1774 8.22187C14.1774 4.79536 11.4013 2.01925 7.9748 2.01925C4.54829 2.01925 1.77218 4.79536 1.77218 8.22187C1.77218 11.6484 4.54829 14.4245 7.9748 14.4245C9.58786 14.427 11.138 13.799 12.2945 12.6745L12.4274 12.5415Z" fill="#6D6F71"/>\n' +
            '</svg>',
        icnType: 'fill'
    },
    {
        name: 'Аккаунт',
        url: {name: 'orders'},
        icn: '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M4.215 13.8371C4.98 13.2521 5.835 12.791 6.78 12.4538C7.725 12.1166 8.715 11.9477 9.75 11.9471C10.785 11.9471 11.775 12.116 12.72 12.4538C13.665 12.7916 14.52 13.2527 15.285 13.8371C15.81 13.2221 16.2189 12.5246 16.5117 11.7446C16.8045 10.9646 16.9506 10.1321 16.95 9.24707C16.95 7.25207 16.2489 5.55317 14.8467 4.15037C13.4445 2.74757 11.7456 2.04647 9.75 2.04707C7.755 2.04707 6.0561 2.74847 4.6533 4.15127C3.2505 5.55407 2.5494 7.25267 2.55 9.24707C2.55 10.1321 2.6964 10.9646 2.9892 11.7446C3.282 12.5246 3.6906 13.2221 4.215 13.8371ZM9.75 10.1471C8.865 10.1471 8.1186 9.84347 7.5108 9.23627C6.903 8.62907 6.5994 7.88267 6.6 6.99707C6.6 6.11207 6.9039 5.36567 7.5117 4.75787C8.1195 4.15007 8.8656 3.84647 9.75 3.84707C10.635 3.84707 11.3814 4.15097 11.9892 4.75877C12.597 5.36657 12.9006 6.11267 12.9 6.99707C12.9 7.88207 12.5964 8.62847 11.9892 9.23627C11.382 9.84407 10.6356 10.1477 9.75 10.1471ZM9.75 18.2471C8.505 18.2471 7.335 18.0107 6.24 17.5379C5.145 17.0651 4.1925 16.424 3.3825 15.6146C2.5725 14.8046 1.9314 13.8521 1.4592 12.7571C0.987 11.6621 0.7506 10.4921 0.75 9.24707C0.75 8.00207 0.9864 6.83207 1.4592 5.73707C1.932 4.64207 2.5731 3.68957 3.3825 2.87957C4.1925 2.06957 5.145 1.42847 6.24 0.95627C7.335 0.48407 8.505 0.24767 9.75 0.24707C10.995 0.24707 12.165 0.48347 13.26 0.95627C14.355 1.42907 15.3075 2.07017 16.1175 2.87957C16.9275 3.68957 17.5689 4.64207 18.0417 5.73707C18.5145 6.83207 18.7506 8.00207 18.75 9.24707C18.75 10.4921 18.5136 11.6621 18.0408 12.7571C17.568 13.8521 16.9269 14.8046 16.1175 15.6146C15.3075 16.4246 14.355 17.066 13.26 17.5388C12.165 18.0116 10.995 18.2477 9.75 18.2471ZM9.75 16.4471C10.545 16.4471 11.295 16.331 12 16.0988C12.705 15.8666 13.35 15.5327 13.935 15.0971C13.35 14.6621 12.705 14.3285 12 14.0963C11.295 13.8641 10.545 13.7477 9.75 13.7471C8.955 13.7471 8.205 13.8635 7.5 14.0963C6.795 14.3291 6.15 14.6627 5.565 15.0971C6.15 15.5321 6.795 15.866 7.5 16.0988C8.205 16.3316 8.955 16.4477 9.75 16.4471ZM9.75 8.34707C10.14 8.34707 10.4625 8.21957 10.7175 7.96457C10.9725 7.70957 11.1 7.38707 11.1 6.99707C11.1 6.60707 10.9725 6.28457 10.7175 6.02957C10.4625 5.77457 10.14 5.64707 9.75 5.64707C9.36 5.64707 9.0375 5.77457 8.7825 6.02957C8.5275 6.28457 8.4 6.60707 8.4 6.99707C8.4 7.38707 8.5275 7.70957 8.7825 7.96457C9.0375 8.21957 9.36 8.34707 9.75 8.34707Z" fill="#6D6F71"/>\n' +
            '</svg>',
        icnType: 'fill'
    },
    {
        name: 'Заказ',
        url: {name: 'checkout'},
        icn: '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M17.27 4.59619H1.72949L3.42179 17.247H15.5757L17.27 4.59619Z" stroke="#6D6F71" stroke-width="1.8"/>\n' +
            '<path d="M4.9858 5.05951L4.55078 1.77795H14.0957L13.8866 5.05951" stroke="#6D6F71" stroke-width="1.8"/>\n' +
            '</svg>',
        icnType: 'stroke'
    }
])

const cart = computed(() => store.state.cart)


const isShowSearch = ref(false)
const showSearch = (el) => {
    if (el.name !== 'Поиск') return
    isShowSearch.value = !isShowSearch.value
}

const closeSearch = () => {
    isShowSearch.value = false
}

</script>

<template>
    <div class="mobile-menu">
        <div class="container">
            <div class="col-sm-4">
                <div class="mobile-menu-inner">
                    <div v-for="el of menuElems">
                        <router-link @click="showSearch(el)" :to="el.url" :class="['menu-item', el.url.name === route.name ? 'active' : '']">
                            <div :class="['icon', el.icnType]" v-html="el.icn"></div>
                            <span class="menu-item-label">{{ el.name }}</span>
                        </router-link>

                        <router-link :to="el.url" ref="cart-svg-notif" class="cart-notification" v-if="el.name === 'Заказ' && cart.totalQuantity > 0">
                            <p>{{ cart.totalQuantity }}</p>
                        </router-link>
                    </div>
                </div>
                <search-overlay v-if="isShowSearch" @close-search="closeSearch"></search-overlay>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;
    .mobile-menu {
        overflow: visible;
        position: fixed;
        left: 0;
        bottom: -1px;
        width: 100%;
        padding: 15px 0 12px;
        border-radius: 21px 21px 0 0;
        background-color: $white;
        box-shadow: $shadow;
        z-index: 150;
        box-sizing: border-box;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .mobile-menu .container {
        width: 88%;
        overflow: visible;
    }

    .mobile-menu-inner {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        flex-direction: row;
        overflow: visible;
    }

    .menu-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        cursor: pointer;
        color: $hard-gray;
    }

    .mobile-menu-inner > div {
        position: relative;
        overflow: visible;
    }

    .menu-item .icon{
        min-height: 18px;
    }

    .menu-item .icon svg {
        width: 100%;
        height: 100% !important;
    }

    .icon path {
        transition: $transition;
        fill: $hard-gray !important;
    }

    .menu-item-label {
        font-size: 11px;
        transition: $transition;
    }

    .menu-item.active, .menu-item:active {
        color: $black
    }

    .menu-item .icon > * > * {
        transition: $transition;
    }

    .menu-item.active .icon.fill > * > *, .menu-item:active .icon.fill > * > * {
        fill: $black !important;
    }

    .menu-item.active .icon.stroke > * > *, .menu-item:active .icon.stroke > * > * {
        stroke: $black;
    }

    .cart-notification {
        background: $purple;
        height: 14px;
        width: 14px;
        position: absolute;
        top: -2px;
        right: 0;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: center;
        cursor: pointer;
        box-sizing: border-box;
    }

    .cart-notification p {
        color: $white;
        font-size: 10px;
        font-family: "PT Sans Narrow";
        line-height: 150%;
    }
</style>